/**
 * @generated SignedSource<<0b9d71e7f3be3e3256c97597d3727795>>
 * @relayHash 5298e24274edcdd24f1530eced4576dd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 863414cde0dcb622159a058828c6866ddc05b90a43abef3314df98010134368a

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { AccountMenuContentContainerQuery } from './AccountMenuContentContainerQuery.graphql';

const node: PreloadableConcreteRequest<AccountMenuContentContainerQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "863414cde0dcb622159a058828c6866ddc05b90a43abef3314df98010134368a",
    "metadata": {},
    "name": "AccountMenuContentContainerQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
